import styled from 'styled-components';
import { Spinner, theme, useMinLoadingState } from '@frameio/vapor';
import { useDelayedState } from '@frameio/vapor-migration';
import TEXT from './generated/TEXT/Loading';

export function Loading({ isLoading }: { isLoading: boolean }) {
  const delayedLoading =
    useDelayedState(isLoading, {
      delay: DELAY,
    }) === true;
  const minLoading = useMinLoadingState(isLoading, MIN);

  return (
    <Container>
      <Spinner
        aria-label={TEXT.spinnerLabel}
        delay={SPINNDER_DELAY} // ignore this one
        isLoading={delayedLoading && minLoading}
        size="x-small"
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  padding-right: ${theme.spaces[2]};
`;

const DELAY = 300;
const MIN = DELAY + 750;
const SPINNDER_DELAY = 0;

TEXT.DEFINE({
  spinnerLabel: 'Loading',
});
